import {gsap} from "../LibrariesImport";

export default class BlockAcrostic {

    static init() {
        const blocks = document.querySelectorAll(".block-acrostic");

        blocks.forEach(block => {
            this.animateBlock(block);
        });
    }

    static animateBlock(block) {
        const getRandomFloat = (min, max) => {
            return Math.random() * (max - min) + min;
        };

        const letters = block.querySelectorAll(".letter");

        letters.forEach(letter => {
            gsap.to(letter, {
                x: "+=5%",
                duration: getRandomFloat(1.5, 2),
                repeat: -1,
                yoyo: true,
                ease: "power1.inOut",
                // Décalage aléatoire pour chaque élément
                delay: getRandomFloat(1.5, 2)
            });

            gsap.to(letter, {
                y: "+=5%",
                duration: getRandomFloat(1.5, 4),
                repeat: -1,
                yoyo: true,
                ease: "power1.inOut",
                // Décalage aléatoire pour chaque élément
                delay: getRandomFloat(1.5, 2)
            });

            gsap.to(letter, {
                opacity: "-=0.3",
                duration: getRandomFloat(1.5, 4),
                repeat: -1,
                yoyo: true,
                ease: "power1.inOut",
                // Décalage aléatoire pour chaque élément
                delay: getRandomFloat(1.5, 3)
            });
        });
    }
}